import { minutesToMs } from '@mi-front/core';
import { ButtonGroup } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { useStationTimeMoveRange } from '../../../../hooks/navigation/useStationTimeMoveRange';
import { useStreamUserDefinedRange } from '../../../../stores/stream-screen.store';
import { TimeMoveButton } from './TimeMoveButton';

const timeMoveBack15mMessage = defineMessage({
  id: 'logger.streamScreen.controls.timeMove.back15m',
  defaultMessage: '-15m',
});
const timeMoveBack1hMessage = defineMessage({
  id: 'logger.streamScreen.controls.timeMove.back1h',
  defaultMessage: '-1h',
});

/**
 * Moves the stream backwards using MUI ButtonGroup.
 * Renders two grouped buttons: -1h and -15m. Each button is enabled when
 * the new window start would not go before the allowed range start (allowed.from).
 */
export function TimeMoveBackwardsControl({ isDisabled = false }: { isDisabled?: boolean }) {
  const { $t } = useIntl();
  const range = useStreamUserDefinedRange();
  const allowed = useStationTimeMoveRange();

  const canMoveBackward = (minutes: number) => range.from - minutesToMs(minutes) >= allowed.from;

  return (
    <ButtonGroup variant="outlined" color="secondary">
      <TimeMoveButton
        label={$t(timeMoveBack1hMessage)}
        minutes={-60}
        disabled={!canMoveBackward(60) || isDisabled}
      />
      <TimeMoveButton
        label={$t(timeMoveBack15mMessage)}
        minutes={-15}
        disabled={!canMoveBackward(15) || isDisabled}
      />
    </ButtonGroup>
  );
}
